<template>
  <div>
    <slot
      :config="config"
      :configModel="configModel"
      :showEditConfig="() => { showEditConfig = true }"
      :submitConfig="onSubmitConfig"
    />
    <lwf-dialog v-model="showEditConfig">
      <q-form
        class="column no-wrap col"
        @submit="onSubmitConfig"
      >
        <form-dashboard-config-table
          v-model="configModel"
          :default-columns="defaultColumns"
          class="q-pa-sm scroll col"
        />
        <q-card-actions
          align="right"
          class="col-auto"
        >
          <q-btn
            type="submit"
            label="Enregistrer"
            color="primary"
          />
        </q-card-actions>
      </q-form>
    </lwf-dialog>
  </div>
</template>

<script>
import LwfDialog from 'components/core/LwfDialog'
import FormDashboardConfigTable from 'components/forms/DashboardConfig/FormDashboardConfigTable'

const DEFAULT_CONFIG = {
  pagination: {
    rowsPerPage: 25
  }
}

export default {
  name: 'TableConfigurationProvider',
  components: { FormDashboardConfigTable, LwfDialog },
  inheritAttrs: false,
  props: {
    defaultColumns: {
      type: Array,
      default: _.stubArray
    },
    defaultConfig: {
      type: Object,
      default: _.stubObject
    },
    filters: {
      type: Object,
      default: _.stubObject
    }
  },
  data () {
    return {
      showEditConfig: false,
      configModel: this._defaultConfig(),
      config: this._defaultConfig()
    }
  },
  watch: {
    filters: {
      immediate: true,
      handler (v) {
        this.$set(this.config, 'filters', v)
      }
    }
  },
  methods: {
    _defaultConfig () {
      return _.merge({}, DEFAULT_CONFIG, this.defaultConfig)
    },
    onSubmitConfig () {
      const { configModel, filters } = this
      this.config = _.cloneDeep({
        ...configModel,
        filters
      })
      this.showEditConfig = false
      this.$emit('saveConfig', this.config)
    }
  }
}
</script>

<style scoped>

</style>
